import ChoiceQuestionTask from 'components/task/types/question/choice/ChoiceQuestionTask';

export default {
	'components.ChoiceQuestionTask': {
		factory: ChoiceQuestionTask,
		deps: [{ $ref: 'components.task.layout.BaseLayout' }, { $ref: 'components.MatchingImageType' }],
	},
};
